import { TextField } from "@mui/material"
import { useFormContext } from "react-hook-form"
import { FormComponent } from "./FormBuilder/types"
import { useEffect } from "react"

const MAX_LENGTH_INPUT = 500

type InputProps = {
  field: string
  component: FormComponent
  width?: string
  helperText?: string
}

export const NameInput = ({ field, component, width = "450px", helperText = "" }: InputProps) => {
  const { register, getValues, watch, setValue } = useFormContext()
  const watchValue = watch(field)

  useEffect(() => {
    if (watchValue && component.editable) {
      setValue(field, watchValue.replaceAll("#", ""))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
  }, [watchValue])

  return (
    <TextField
      required={!!component.required}
      disabled={!component.editable}
      rows={3}
      inputProps={{
        maxLength: MAX_LENGTH_INPUT,
      }}
      type="text"
      variant="outlined"
      size="small"
      helperText={helperText}
      error={!!helperText}
      sx={{ width: `${width}` }}
      {...register(field)}
    />
  )
}
